import React from 'react';

const InstrumentDetailRightMenu = () => {
  return <></>;
};

export default InstrumentDetailRightMenu;
